"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, /**
 * Primary UI component for user interaction
 */ "default", {
    enumerable: true,
    get: function() {
        return FieldLabel;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _react = /*#__PURE__*/ _interop_require_default(require("react"));
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n    border-radius: 10px;\n    border: 1px solid #e9ecef;\n    padding: 20px;\n    margin-bottom: 10px;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FieldLabel(param) {
    var title = param.title, value = param.value, handleClick = param.handleClick;
    var Wrapper = _styled.default.div(_templateObject());
    return /*#__PURE__*/ (0, _jsxruntime.jsxs)(Wrapper, {
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, _jsxruntime.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxruntime.jsx)("p", {
                children: value
            })
        ]
    });
}
